import { render, staticRenderFns } from "./jd-select-input.vue?vue&type=template&id=6883d346&scoped=true&"
import script from "./jd-select-input.vue?vue&type=script&lang=js&"
export * from "./jd-select-input.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6883d346",
  null
  
)

export default component.exports